import React, { useState } from "react";
import ReactDOM from "react-dom";
import CloseCommand from "../Commands/CloseCommand/CloseCommand";
import SpinnerIcon from "../Commands/SpinnerIcon/SpinnerIcon.js";
import "./SimpleModal.css";

export default function CustomLoading (props)  {
  
 return ReactDOM.createPortal(
        <React.Fragment>
          <div className="modal-overlay"  />
          <div
            className="modal-wrapper"
            aria-modal
            aria-hidden
            tabIndex={-1}
            role="dialog"
            
          >
            <div className="modal" style = {{background : "transparent", width:"50px" }} >
              <SpinnerIcon color = "white" size = "50px" />
            </div>
          </div>
        </React.Fragment>,
        document.body
      )
  }

